export enum EnvName {
    LOCAL = 'local',
    STAGING = 'staging',
    developement = 'development'
}
